import { render, staticRenderFns } from "./PoupupResetPassword.vue?vue&type=template&id=0ef1f9aa&scoped=true"
import script from "./PoupupResetPassword.vue?vue&type=script&lang=js"
export * from "./PoupupResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef1f9aa",
  null
  
)

export default component.exports